import { useState, useRef, useEffect } from "react";
import { getClasses } from "../utils";
import { useAnimations } from "../hooks";
import classes from "../styles/Spinner.module.css";

const Spinner: React.FC<{
  visible: boolean;
  name?: string;
  size?: number;
  stroke?: number;
  full?: boolean;
}> = (props) => {
  const id = `spinner-${props.name || Date.now()}`;
  const animations = {
    show: {
      duration: 0.1,
      opacity: 1,
      // NOTE: it is called "atStart/atEnd" in order to be different than the gsap "onStart/onEnd"
      atStart: () => setHidden(false),
    },
    hide: {
      duration: 0.6,
      opacity: 0,
      atEnd: () => setHidden(true),
    },
  };

  // const [visible, setVisible] = useState(props.visible as boolean);
  const [hidden, setHidden] = useState(true);
  const container = useRef(null);
  const [animationClass, setAnimation] = useAnimations(
    animations,
    id,
    container
  );

  useEffect(() => {
    setAnimation(props.visible ? "show" : "hide");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  if (hidden) return null;
  // if the spinner is "full" the background of the spin is set to the "dark" color and its position is absolute
  const typeClass = props.full ? "full" : "";
  const size = props.size && props.size > 0 ? props.size : 50;
  const stroke = props.stroke && props.stroke > 0 ? props.stroke : 4;

  return (
    <div
      ref={container}
      className={getClasses(
        classes,
        "spinner-container",
        typeClass,
        animationClass
      )}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g strokeWidth={stroke} className={classes.spinner}>
          <circle cx="12" cy="12" r="9.5" fill="none"></circle>
        </g>
      </svg>
    </div>
  );
};

export default Spinner;
